export var RangeState;

(function (RangeState) {
  RangeState["NONE"] = "";
  RangeState["SINGLE"] = "single";
  RangeState["IN"] = "in";
  RangeState["START"] = "start";
  RangeState["END"] = "end";
  RangeState["PREV"] = "prev";
  RangeState["NEXT"] = "next";
})(RangeState || (RangeState = {}));